import { render, staticRenderFns } from "./ExerciseMedia.vue?vue&type=template&id=25e2bd3a&"
import script from "./ExerciseMedia.vue?vue&type=script&lang=js&"
export * from "./ExerciseMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports